import { create } from 'zustand';
import {
	ExpressOffer,
	OfferListItem,
	OffersListResponse,
	OfferStatus,
	PaginationData,
} from '../types';

interface SpecialistOffersState {
	// Listing state
	offers: OfferListItem[];
	isLoading: boolean;
	error: string | null;
	pagination: PaginationData;

	// Filters
	status: OfferStatus;

	// Selected offer details
	selectedOffer: ExpressOffer | null;
	isOfferDetailLoading: boolean;
	offerDetailError: string | null;

	// Actions
	setOffers: (offers: OffersListResponse) => void;
	setStatus: (status: OfferStatus) => void;
	setIsLoading: (isLoading: boolean) => void;
	setError: (error: string | null) => void;
	setSelectedOffer: (offer: ExpressOffer | null) => void;
	setIsOfferDetailLoading: (isLoading: boolean) => void;
	setOfferDetailError: (error: string | null) => void;

	// Reset state
	resetState: () => void;
}

export const useSpecialistOffersStore = create<SpecialistOffersState>((set) => ({
	// Listing state
	offers: [],
	isLoading: false,
	error: null,
	pagination: {
		total_pages: 0,
		current_page: 1,
		items_per_page: 10,
		total_items: 0,
	},

	// Filters
	status: 'active',

	// Selected offer details
	selectedOffer: null,
	isOfferDetailLoading: false,
	offerDetailError: null,

	// Actions
	setOffers: (offersResponse: OffersListResponse) =>
		set(() => ({
			offers: offersResponse.data,
			pagination: offersResponse.pagination,
			isLoading: false,
			error: null,
		})),

	setStatus: (status: OfferStatus) => set(() => ({ status })),

	setIsLoading: (isLoading: boolean) => set(() => ({ isLoading })),

	setError: (error: string | null) => set(() => ({ error, isLoading: false })),

	setSelectedOffer: (offer: ExpressOffer | null) =>
		set(() => ({
			selectedOffer: offer,
			isOfferDetailLoading: false,
			offerDetailError: null,
		})),

	setIsOfferDetailLoading: (isLoading: boolean) => set(() => ({ isOfferDetailLoading: isLoading })),

	setOfferDetailError: (error: string | null) =>
		set(() => ({ offerDetailError: error, isOfferDetailLoading: false })),

	// Reset state
	resetState: () =>
		set(() => ({
			offers: [],
			isLoading: false,
			error: null,
			pagination: {
				total_pages: 0,
				current_page: 1,
				items_per_page: 10,
				total_items: 0,
			},
			status: 'active',
			selectedOffer: null,
			isOfferDetailLoading: false,
			offerDetailError: null,
		})),
}));
